import { ref } from "@vue/composition-api";

// TODO rename to 'asyncRef' to be consistent with 'ref' itself
export const useAsyncRef = <T>(source: () => Promise<T>) => {
  const item = ref<T | null>(null);

  source().then((val) => {
    item.value = val;
  });

  return item;
};
